<template>
  <div class="">

<div class="bash-wrap">
            <div class="bash-box product-box">
                <p class="h1-title">{{indata.FirstTitle}}</p>
                <p class="h2-title">{{indata.subTitle}}</p>
                <ul class="product-nav-ul">
                    <li :class="NowIndex==index?'active':''" @mouseenter="changeActive(index)"  v-for="(item,index) in indata.children" :key="index">
                        <i class="drp" :style="'background: url('+item.icon+') no-repeat 50% 50%;'"></i>
                        <p class="nav-title">{{item.title}}</p>
                        <span class="bottom-arrow"></span>
                    </li>
                </ul>
            </div>
            <div class="product-content-wrap">
                <ul class="bash-box product-content-ul">
                    <li :class="NowIndex==index?'active':''"  v-for="(item,index) in indata.children" :key="index">
                        <div class="product-content-left">
                            <p class="detail">{{item.introduce}}</p>
                            <a class="go-next" :href="item.url" target="_blank" >查看详情</a>
                        </div>
                        <div class="product-content-right">
                            <i class="product-1" :style="'background: url('+item.showImage+') no-repeat 50% 100%;'"></i>
                        </div>
                    </li>
                
                </ul>
            </div>
        </div>

  </div>
</template>


<script>
export default {
  name: "Templates1",
  props:{
    indata:Array
  },
  data(){
    return{
      NowIndex:0
    }
  }
  ,
  methods :{
changeActive(index){
  this.NowIndex=index
}
  }
};
</script>
